<template>
  <el-menu class="navbar" mode="horizontal">
    <hamburger class="hamburger-container" :toggleClick="toggleSideBar" :isActive="sidebar.opened"></hamburger>
    <breadcrumb></breadcrumb>
    <el-dropdown class="avatar-container" trigger="click">
      <div class="avatar-wrapper">
        <img class="user-avatar" :src="avatar">
        <i class="el-icon-caret-bottom"></i>
      </div>
      <el-dropdown-menu class="user-dropdown" slot="dropdown">
        <router-link class="inlineBlock" to="/back/home">
          <el-dropdown-item>
            后台首页
          </el-dropdown-item>
        </router-link>
        <router-link class="inlineBlock" to="/">
          <el-dropdown-item>
            官网首页
          </el-dropdown-item>
        </router-link>
        <el-dropdown-item divided>
          <span @click="logout" style="display:block;">退出</span>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </el-menu>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'

export default {
  components: {
    Breadcrumb,
    Hamburger
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar'
    ])
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('ToggleSideBar')
    },
    logout() {
      this.$store.dispatch('LogOut').then(() => {
        location.reload() // 为了重新实例化vue-router对象 避免bug
      })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "src/styles/variables.scss";

.navbar {
  height: 60px;
  line-height: 60px;
  border-radius: 0px !important;
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  border-bottom: none;
  
  .hamburger-container {
    line-height: 60px;
    height: 60px;
    float: left;
    padding: 0 20px;
    cursor: pointer;
    transition: all 0.3s ease;
    
    &:hover {
      background: rgba(99, 102, 241, 0.08);
    }
  }
  
  .screenfull {
    position: absolute;
    right: 90px;
    top: 16px;
    color: red;
  }
  
  .avatar-container {
    height: 60px;
    display: inline-block;
    position: absolute;
    right: 35px;
    
    .avatar-wrapper {
      cursor: pointer;
      margin-top: 10px;
      position: relative;
      display: flex;
      align-items: center;
      padding: 8px 16px;
      border-radius: $border-radius-md;
      transition: all 0.3s ease;
      
      &:hover {
        background: rgba(99, 102, 241, 0.08);
      }
      
      .user-avatar {
        width: 40px;
        height: 40px;
        border-radius: 12px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        transition: all 0.3s ease;
        
        &:hover {
          transform: scale(1.05);
          box-shadow: 0 4px 12px rgba(99, 102, 241, 0.3);
        }
      }
      
      .el-icon-caret-bottom {
        position: absolute;
        right: -4px;
        top: 28px;
        font-size: 14px;
        color: $text-secondary;
        transition: all 0.3s ease;
      }
    }
  }
}

// 下拉菜单样式
::v-deep .user-dropdown {
  border-radius: $border-radius-md;
  box-shadow: $shadow-lg;
  border: none;
  margin-top: 8px;
  
  .el-dropdown-menu__item {
    border-radius: $border-radius-sm;
    margin: 4px 8px;
    transition: all 0.2s ease;
    font-weight: 500;
    
    &:hover {
      background: rgba(99, 102, 241, 0.1);
      color: $primary-color;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue